<nav class="navbar fixed-top navbar-expand-lg navbar-dark white-background scrolling-navbar ie-nav box-shadow"
  [ngClass]="{ 'padded-navbar': padding ,'guest-nav':isGuest}">
  <div class="container loggedout" [ngClass]="{ 'mx-wd-tablet-desktop ml-auto mr-auto': !isAcmic,'acmic-guest-header':isGuest && isAcmic,'guest-header':isGuest }">
    <div class="brand">
      <ng-container *ngIf="isAcmic; else maLogo">
        <div class="acmic-logo">
                <img src="./assets/img/images/logos/Group 1.svg" alt="AAA Insurance" class="acmic-new-logo" />
                <div class="acmic-header-text">
                  <img class="acmic-accordian" src="assets/img/images/Untitled.svg">
                  <!-- <span class="acmic-header-new">Guest Payment</span> -->
                   <ng-container *ngIf="!isGuest; else acmicGuestHeader">
                    <span class="header-logo-text">My account</span>        
                  </ng-container>
                  <ng-template #acmicGuestHeader>
                    <span class="header-logo-text">{{ guestTitle }}</span>        
                  </ng-template>
                </div>
              </div>
      </ng-container>
      <ng-template #maLogo>
        <a target="_blank" href="https://www.mapfreinsurance.com">
          <img [src]="logoPath" [alt]="altText" class="logo" />
        </a>   
        <img class="ml-3 mr-3 separation-tag" src="assets/img/images/seperation-icon.svg">
        <ng-container *ngIf="!isGuest; else guestHeader">
          <span class="header-logo-text">My account</span>        
        </ng-container>
        <ng-template #guestHeader>
          <span class="header-logo-text">{{ guestTitle }}</span>        
        </ng-template>
      </ng-template> 
    </div>
    <div class="navbar-nav nav-flex-icons" *ngIf="!hideModal && !isGuest">
      <mapfre-modal 
        [modalOptions]="headerHelpModalOptions" 
        (openModal)="onOpenModal()"
      >
        <div class="modal-body" *ngIf="helpModalOpened">
          <hr class="margin-bottom mb24 no-margin-top" />
          <div class="modal-body-title font-weight-500">
            {{ "MODAL_HELP_TROUBLE_ACCESSING" | translate }}
          </div>
          <div class="modal-body-content">
            {{ "OUR_CUSTOMER_SER_DEPT_HELP" | translate }}
          </div>
        </div>        
        <div *ngIf="helpModalOpened" style="display: contents">
          <ng-container *ngIf="isAcmic; else otherStateCall">
            <a href="tel:{{ 'CALL_US_NUMBER' | translate }}" class="grid-modal-footer two-column modal-footer">
            <div class="mapfre-information-container">
              <div class="mapfre-icon-information row">
                <div class="col">
                  <div class="icon-container align-middle">
                    <figure><img alt="Call us" src="assets/img/icons/phone-icon.svg"></figure>
                  </div>
                  <div class="information-container">
                    <div class="title">{{ 'CALL_US' | translate }}</div>
                    <div class="data">{{ 'CALL_US_NUMBER' | translate }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <img src="assets/SVG/acmic-icon-simple-arrow-right.svg" alt="right arrow icon" />
            </div>
          </a>
          </ng-container>
          <ng-template #otherStateCall>
            <div class="grid-modal-footer two-column modal-footer">
              <div class="mapfre-information-container">
                <div class="mapfre-icon-information row">
                  <div class="col contact-us">
                    <div class="icon-container align-middle">
                      <figure><img alt="Call us" src="assets/img/icons/icon-phone.svg"></figure>
                    </div>
                    <div class="information-container">
                      <div class="title font-weight-bold">{{ 'CONTACT_US_TEXT' | translate }}</div>
                      <!-- <div class="data">{{ 'CALL_US_NUMBER' | translate }}</div> -->
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <a target="_blank" href="https://www.mapfreinsurance.com/contact/">
                  <img src="assets/img/images/icon-simple-arrow-right.svg" alt="right arrow icon" />
                </a>
              </div>
            </div>
          </ng-template>
        </div>
        <a href="mailto:{{ 'EMAIL_US_EMAIL' | translate }}" class="grid-modal-footer two-column modal-footer" *ngIf="helpModalOpened">
          <ng-container *ngIf="isAcmic; else otherStateEmail">
          <div class="mapfre-information-container">
              <div class="mapfre-icon-information row">
                <div class="col">
                  <div class="icon-container align-middle">
                    <figure><img alt="Email us" src="assets/img/icons/email-icon.svg"></figure>
                  </div>
                  <div class="information-container">
                    <div class="title">{{ 'EMAIL_US' | translate }}</div>
                    <div class="data">{{ 'EMAIL_US_EMAIL' | translate }}</div>
                  </div>
                </div>
              </div>
              </div>
              <div>
                <img src="assets/SVG/acmic-icon-simple-arrow-right.svg" alt="right arrow icon" />
              </div>
            </ng-container>
            <ng-template #otherStateEmail>
              <div class="mapfre-information-container">
                <div class="mapfre-icon-information row">
                    <div class="col">
                      <div class="icon-container align-middle">
                        <figure><img alt="Email us" src="assets/img/icons/icon-email.svg"></figure>
                      </div>
                      <div class="information-container">
                        <div class="title font-weight-bold">{{ 'EMAIL_US' | translate }}</div>
                        <div class="data">{{ 'EMAIL_US_EMAIL' | translate }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <img src="assets/img/images/icon-simple-arrow-right.svg" alt="right arrow icon"/>
                </div>
            </ng-template>
          
        </a>
      </mapfre-modal>
    </div>
  </div>
</nav>